export interface StreamHandlers<TResponse = any> {
  onData: (response: TResponse) => void
  onError?: (payload: { details?: any; message: string }) => void
  onConnect?: (payload: { attempt: number; isReconnect: boolean }) => void
  onDisconnect?: (payload: {
    reason: string
    attempt?: number
    willRetry: boolean
  }) => void
  onRetry?: (payload: {
    attempt: number
    delayMs: number
    nextBackoff: null | number
  }) => void
}

export enum StreamKey {
  // Infrastructure (always enabled, cannot be toggled off)
  Infrastructure = 'infrastructure',

  // Core streams (default: enabled)
  Orderbook = 'orderbook',
  MarkPrices = 'mark-prices',

  // Spot streams (default: disabled)
  SpotTrades = 'spot-trades',
  SpotOrders = 'spot-orders',
  SpotOrderHistory = 'spot-order-history',
  SpotTradesSubaccount = 'spot-trades-subaccount',
  SpotAverageEntries = 'spot-average-entries',

  // Derivative streams (default: disabled)
  DerivativeTrades = 'derivative-trades',
  DerivativeOrders = 'derivative-orders',
  DerivativeOrderHistory = 'derivative-order-history',
  DerivativeTradesSubaccount = 'derivative-trades-subaccount',

  // Account streams (default: disabled)
  Positions = 'positions',
  BankBalance = 'bank-balance',
  SubaccountBalance = 'subaccount-balance',
  GridStrategies = 'grid-strategies'
}

export enum StreamCategoryKey {
  Trades = 'trades',
  Orders = 'orders',
  Balances = 'balances',
  Orderbook = 'orderbook',
  Positions = 'positions',
  MarkPrices = 'markPrices',
  OrderHistory = 'orderHistory',
  GridStrategies = 'gridStrategies',
  Infrastructure = 'infrastructure',
  TradesSubaccount = 'tradesSubaccount'
}

export enum StreamLogType {
  Error = 'error',
  Warn = 'warn',
  Log = 'log'
}
